import { useState, useEffect } from "react";
import { X, Download, Smartphone } from "lucide-react";
import { Button } from "./ui/button";

export default function InstallPWA() {
  const [showBanner, setShowBanner] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Verificar se já está instalada
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
      setIsInstalled(true);
      return;
    }

    // Verificar se o utilizador já dispensou o banner
    const dismissed = localStorage.getItem("pwa-banner-dismissed");
    if (dismissed) {
      const dismissedAt = new Date(dismissed);
      const daysSince = (Date.now() - dismissedAt.getTime()) / (1000 * 60 * 60 * 24);
      if (daysSince < 7) return; // Não mostrar durante 7 dias após dispensar
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    // Verificar instalação
    window.addEventListener("appinstalled", () => {
      setIsInstalled(true);
      setShowBanner(false);
      setDeferredPrompt(null);
    });

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setIsInstalled(true);
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem("pwa-banner-dismissed", new Date().toISOString());
  };

  if (!showBanner || isInstalled) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9998] bg-slate-900 text-white p-3 shadow-2xl border-t border-slate-700 animate-in slide-in-from-bottom duration-300 lg:bottom-4 lg:left-auto lg:right-4 lg:w-96 lg:rounded-xl lg:border"
      data-testid="install-pwa-banner"
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-blue-600 flex items-center justify-center shrink-0">
          <Smartphone className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm">Instalar EP3D MES</p>
          <p className="text-xs text-slate-300">Acesso rápido como app nativa</p>
        </div>
        <Button
          size="sm"
          className="bg-blue-600 hover:bg-blue-700 text-white shrink-0 gap-1"
          onClick={handleInstall}
          data-testid="install-pwa-btn"
        >
          <Download className="h-3.5 w-3.5" />
          Instalar
        </Button>
        <button
          onClick={handleDismiss}
          className="text-slate-400 hover:text-white shrink-0 p-1"
          data-testid="dismiss-pwa-btn"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
